import React from 'react';

import NoResultsIcon from 'icons/noresults-xl.svg';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

export default function BlankPersonnelSearchResults({
  allowAdditionalSearching,
  allowFilterChange,
  isArchived,
  onFilterInclusionClick,
  onSetToggle,
  search,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <div className='section section--notice tw-rounded-t-none tw-border-grey-100 tw-bg-white'>
      <NoResultsIcon
        className='[&_path]:tw-fill-grey-300'
        height={64}
        width={64}
      />
      <h2 className='section__header tw-text-l tw-font-semibold tw-text-grey-900'>
        {i18nTShared('noResultsFoundForSearch', {
          interpolation: { escapeValue: false },
          search,
        })}
      </h2>
      <p className='section__content tw-my-2'>
        {allowAdditionalSearching &&
          (allowFilterChange ?
            <Trans
              components={{
                filtersA: (
                  /* eslint-disable jsx-a11y/anchor-has-content */
                  <a
                    className='app-link tw-align-baseline tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
                    href='#0'
                    onClick={onFilterInclusionClick}
                  />
                  /* eslint-enable jsx-a11y/anchor-has-content */
                ),
                toggleA: (
                  /* eslint-disable jsx-a11y/anchor-has-content */
                  <a
                    className='app-link tw-align-baseline tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
                    href='#0'
                    onClick={onSetToggle}
                  />
                  /* eslint-enable jsx-a11y/anchor-has-content */
                ),
              }}
              i18nKey={`personnel.BlankPersonnelSearchResults.description.${isArchived ? 'archived' : 'active'}WithFilters`}
              ns='components'
            />
          : <Trans
              components={{
                a: (
                  /* eslint-disable jsx-a11y/anchor-has-content */
                  <a
                    className='app-link tw-align-baseline tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
                    href='#0'
                    onClick={onSetToggle}
                  />
                  /* eslint-enable jsx-a11y/anchor-has-content */
                ),
              }}
              i18nKey={`personnel.BlankPersonnelSearchResults.description.${isArchived ? 'archived' : 'active'}`}
              ns='components'
            />)}
      </p>
    </div>
  );
}

BlankPersonnelSearchResults.propTypes = {
  allowAdditionalSearching: PropTypes.bool.isRequired,
  allowFilterChange: PropTypes.bool.isRequired,
  isArchived: PropTypes.bool,
  onFilterInclusionClick: PropTypes.func,
  onSetToggle: PropTypes.func,
  search: PropTypes.string.isRequired,
};
